module.exports = __webpack_public_path__ + "static/media/collaboration.0d8564f9.png";